/**
 * paramMsgString.js
 *
 * @Author: jruif
 * @Date: 2018/2/25 下午1:45
 */

import React from 'react';
import RepostTip from './repostTip';
import ContractConfirmDialog from '../../mcn/container/memberManage/contractConfirmDialog';

const paramMsgString = (str, wemediaId) => {
  const p = document.createElement('p');
  p.innerHTML = str;
  return [].map.call(p.childNodes, (item, i) => {
    const classes = item.className ? item.className.split(' ') : [];
    if (item.dataset && item.dataset.mcn) {
      return (
        <ContractConfirmDialog
          isPreview={false}
          key={i}
          formData={item.dataset}
          trigger={
            <span>
              {item.innerText}
              <button className="red-font">查看内容</button>
            </span>
          }
        />
      );
    }
    if (item.nodeType === 3) {
      return item.textContent;
    }

    if (item.nodeType === 1 && item.nodeName !== 'A') {
      return null;
    }

    if (classes.indexOf('j-repost') === -1) {
      let href = /^https?:/.test(item.href) ? item.href : '//' + window.location.host + item.href;
      return (
        <a key={i} className="blue-font" href={href} target={item.target || '_self'}>
          {item.innerText}
        </a>
      );
    }
    return (
      <RepostTip
        key={i}
        className="tool-tip"
        position="bottomRight"
        content={<span className="blue-font"> {item.innerText} </span>}
        trigger="click"
        dataset={item.dataset}
        wemediaId={wemediaId}>
        {`是否转载 ${item.dataset.tname} 的${item.dataset.type === 'live' ? '直播' : '文章'}《${
          item.dataset.name
        }》吗?`}
      </RepostTip>
    );
  });
};

export default paramMsgString;
